@import "../../../../css/_mixins.scss";

.yesBtn,
.noBtn {
  border: 25px;
  margin-inline: 7px;
  padding-inline: 22px;
  color: white;
  font-size: 17px;
  float: right;
  height: 50px;
  border-radius: 25px;
  font-weight: bold;
  margin: 10px;
}
.yesBtn {
  background-color: var(--yellow);
}

.noBtn {
  background-color: var(--red);
}

.container {
  .content {
    display: flex;
    justify-content: center;
    gap: 2vh;
    align-items: center;
    flex-direction: column;
    width: 100%;
    min-height: 75vh;
    padding: 16px;
    background: var(--bg-onboarding) no-repeat center;
    background-size: cover;
    text-align: center;

    .addToDonationTestMsg {
      color: var(--red);
      text-align: center;
      font-weight: bold;
    }

    .divAddToDonation {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      color: var(--red);
      justify-content: center;
      align-items: center;
      background-color: #ddd;
      margin: 15px auto;
      padding: 14px 20px;
      border-radius: 20px;
      max-width: 100%;
      box-sizing: border-box;

      @include mobile {
        gap: 8px;
        padding: 12px 14px;
        font-size: 14px;
      }

      .addToDonationBtn {
        font-weight: bold;
        color: #fff;
        font-size: 15px;
        background-color: var(--red);
        cursor: pointer;
        padding: 8px 16px;
        border-radius: 20px;
        border: 0;

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      .amountInput {
        color: var(--red);
        border: 1px solid var(--red);
        border-radius: 10px;
        width: 90px;
        height: 36px;
        font-size: 19px;
        text-align: center;
        padding: 0 8px;
        box-sizing: border-box;
      }
    }

    .caption {
      color: darkgray;
      font-weight: bold;
      font-size: 26px;
    }

    .title {
      max-width: 90%;
      text-align: center;
      color: var(--red);
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 1.15;

      @include small-desktop {
        font-size: 32px;
      }
      @include tablet {
        font-size: 24px;
      }
      @include mobile {
        font-size: 22px;
      }

      .imgLogo {
        max-width: 280px;
        width: 100%;
        height: auto;
      }
    }

    .imgCard {
      display: block;
      margin-top: 24px;
      margin-bottom: 16px;
      max-width: 260px;
      width: 100%;
      height: auto;

      @include tablet {
        max-width: 220px;
      }
      @include mobile {
        max-width: 180px;
        margin-top: 16px;
      }
    }

    .multiInfo {
      margin-top: 40px;
      max-width: 540px;
      color: var(--gray);
      text-align: center;
      font-size: 22px;
      line-height: 32px;
      font-weight: 600;
      letter-spacing: 0px;
    }

    .multiInputWrapper {
      position: relative;
      max-width: 400px;
      padding: 0 56px;
      margin-top: 16px;

      .multiInputCode {
        width: 100%;
        height: 70px;
        text-align: center;
        font-size: 32px;
        color: var(--red);
        text-align: center;
        letter-spacing: -1px;
        border: 3px solid var(--red);
        border-radius: 35px;
        text-transform: uppercase;
      }

      i {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        color: var(--red);
        font-size: 32px;
        cursor: pointer;
      }
    }

    .errorMessage {
      max-width: 80%;
      text-align: center;
      color: var(--red);
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
    }

    .redemptionDetail {
      display: flex;
      flex-wrap: wrap;
      gap: 24px;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      max-width: 880px;
      margin-top: 12px;

      // Stack at small-desktop+ so two 400px inputs can't try to fit
      // side-by-side in 700–900px viewports (where they were cramped).
      @include small-desktop {
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: center;
        gap: 12px;
        max-width: 100%;
      }

      .inputWrapper {
        flex: 0 1 400px;
        max-width: 100%;
        min-width: 0;

        @include small-desktop {
          flex: 0 1 auto;
          width: 100%;
          max-width: 420px;
        }

        .inputCode {
          width: 100%;
          height: 70px;
          text-align: center;
          font-size: 40px;
          color: var(--red);
          font-weight: bold;
          letter-spacing: -1px;
          border: 3px solid var(--red);
          border-radius: 30px;
          text-transform: uppercase;
          box-sizing: border-box;

          @include small-desktop {
            height: 60px;
            font-size: 36px;
          }
          @include tablet {
            height: 56px;
            font-size: 30px;
          }
          @include mobile {
            height: 52px;
            font-size: 26px;
          }
        }

        .linkChangeCode {
          margin-top: 5px;
          color: var(--primary);
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 0px;
          text-decoration: none !important;
          cursor: pointer !important;

          @include tablet {
            margin: 4px 0 0;
            font-size: 16px;
          }
        }

        .inputEmail {
          width: 100%;
          height: 70px;
          padding: 7px 16px;
          color: var(--red);
          letter-spacing: 0;
          text-align: center;
          border: 2px solid var(--red);
          border-radius: 30px;
          box-sizing: border-box;

          @include small-desktop {
            height: 60px;
            font-size: 22px;
            margin-top: 0;
          }
          @include tablet {
            height: 56px;
            font-size: 20px;
          }
          @include mobile {
            height: 52px;
            font-size: 18px;
          }
        }

        .lblEmail {
          margin-top: 10px;
          color: var(--red);
          text-align: center;
          font-size: 16px;
          font-style: italic;
          letter-spacing: 0px;
          @include mobile {
            font-size: 14px;
          }
        }
      }
    }

    .termsWrapper {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      max-width: 700px;
      margin: 32px auto 0;
      padding: 0 12px;
      box-sizing: border-box;
      text-align: left;

      @include tablet {
        margin-top: 24px;
      }

      .termsRadio {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        margin-top: 2px;
        border: 2px solid var(--red);
      }

      .lblTerms {
        display: block;
        flex: 1;
        margin-left: 12px;
        font-size: 16px;
        line-height: 22px;
        text-align: left;
        color: var(--gray);
        letter-spacing: 0px;

        @include mobile {
          font-size: 14px;
          line-height: 20px;
          margin-left: 10px;
        }
      }
      .termsLinkButton {
        display: inline;
        padding: 0;
        border: 0;
        background: transparent;
        color: var(--red);
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .lblError {
      margin-top: 40px;
      color: var(--red);
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
